var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfirmation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5017 1.83333H16.3333C17.3417 1.83333 18.1667 2.65833 18.1667 3.66667V16.5C18.1667 17.5083 17.3417 18.3333 16.3333 18.3333H3.5C3.37167 18.3333 3.2525 18.3242 3.13333 18.3058C2.77583 18.2325 2.455 18.0492 2.2075 17.8017C2.0425 17.6275 1.905 17.435 1.81333 17.215C1.72167 16.995 1.66667 16.7475 1.66667 16.5V3.66667C1.66667 3.41 1.72167 3.17167 1.81333 2.96083C1.905 2.74083 2.0425 2.53917 2.2075 2.37417C2.455 2.12667 2.77583 1.94333 3.13333 1.87C3.2525 1.8425 3.37167 1.83333 3.5 1.83333H7.33167C7.71667 0.77 8.725 0 9.91667 0C11.1083 0 12.1167 0.77 12.5017 1.83333ZM14.1242 6.03174L15.4167 7.33341L8.08333 14.6667L4.41667 11.0001L5.70917 9.70757L8.08333 12.0726L14.1242 6.03174ZM9.91667 1.60417C10.2925 1.60417 10.6042 1.91583 10.6042 2.29167C10.6042 2.6675 10.2925 2.97917 9.91667 2.97917C9.54083 2.97917 9.22917 2.6675 9.22917 2.29167C9.22917 1.91583 9.54083 1.60417 9.91667 1.60417ZM3.50016 16.5011H16.3335V3.66781H3.50016V16.5011Z",
    fill: "#929F9A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmation);
export default __webpack_public_path__ + "static/media/confirmation.81eb20a1.svg";
export { ForwardRef as ReactComponent };